import Logger from './logger';

const AUTH_FLOWS = {
  SIGN_IN: 'sign-in',
  SIGN_UP: 'sign-up',
  RESET_PASSWORD: 'reset-password',
};

const AUTH_METHODS = {
  PHONE_CODE: 'phone-code',
  EMAIL_CODE: 'email-code',
  EMAIL_PASS: 'email-pass',
};

const AUTH_STEPS = {
  CAPTURE_PHONE: 'capture-phone',
  VERIFY_PHONE_CODE: 'verify-phone-code',
  CAPTURE_EMAIL: 'capture-email',
  VERIFY_EMAIL_CODE: 'verify-email-code',
  CAPTURE_PASSWORD: 'capture-password',
  CAPTURE_SIGNUP_DETAILS: 'capture-signup-details',
  REQUEST_RESET_EMAIL: 'request-reset-email',
  SET_NEW_PASSWORD: 'set-new-password',
};

const AUTH_ACTIONS = {
  CONTINUE: 'continue',
  SUBMIT: 'submit',
  RESEND_CODE: 'resend-code',
  SWITCH_METHOD: 'switch-method',
  OPEN_SIGN_UP: 'open-sign-up',
  OPEN_SIGN_IN: 'open-sign-in',
  OPEN_RESET_PASSWORD: 'open-reset-password',
  REQUEST_EMAIL_CODE: 'request-email-code',
};

const SIGN_IN_METHOD_MAP = {
  phone: AUTH_METHODS.PHONE_CODE,
  'email code': AUTH_METHODS.EMAIL_CODE,
  'email pass': AUTH_METHODS.EMAIL_PASS,
};

const sanitizeErrorMessage = (value) => {
  if (!value || typeof value !== 'string') {
    return value || 'unknown';
  }
  return value
    .replace(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi, '[redacted-email]')
    .replace(/\+?\d[\d\s().-]{6,}\d/g, '[redacted-phone]')
    .replace(/\b\d{6}\b/g, '[redacted-code]');
};

const normalizeAuthMethod = (method) => SIGN_IN_METHOD_MAP[method] || method || AUTH_METHODS.EMAIL_PASS;

const buildAuthDdActionName = ({
  flow,
  method,
  step,
  action,
}) => `auth|flow:${flow}|method:${method}|step:${step}|action:${action}`;

const trackAuthDdAction = (actionName, payload = {}) => {
  if (!actionName) return;
  if (typeof window !== 'undefined' && window.DD_RUM?.addAction) {
    window.DD_RUM.addAction(actionName, payload);
  }
};

const logAuthApiError = ({
  flow,
  method,
  step,
  endpoint,
  error,
  isWidget = false,
}) => {
  const errorPayload = error?.data || error;
  const statusCode = errorPayload?.status || errorPayload?.statusCode || errorPayload?.data?.status;
  const errorCode = errorPayload?.code || errorPayload?.data?.code || errorPayload?.data?.error_code;
  const message = errorPayload?.message || errorPayload?.data?.message || error?.message || 'Unknown auth API error';

  Logger.error({
    name: 'auth_api_error',
    flow,
    method: normalizeAuthMethod(method),
    step,
    endpoint,
    status_code: statusCode || 'unknown',
    error_code: errorCode || 'unknown',
    error_message: sanitizeErrorMessage(message),
    is_widget: Boolean(isWidget),
  });
};

export {
  AUTH_ACTIONS,
  AUTH_FLOWS,
  AUTH_METHODS,
  AUTH_STEPS,
  buildAuthDdActionName,
  logAuthApiError,
  normalizeAuthMethod,
  trackAuthDdAction,
};
